<template>
  <div class="m-main">
    <Header></Header>
    <div class="m-main-bg">
      <!-- <div class="m-main-bg-img"> -->
      <img class="img" src="../../assets/img/gaokao.jpeg" alt="">
      <!-- </div> -->
    </div>
    <div class="card-contain">
      <div v-for="(item, i) in cardData" :key="i" class="card-contain__item" @click="goToFn(item.url)">
        <div class="img"><img :src="item.imgsrc" /></div>
        <div class="title">{{ item.title }}</div>
        <div class="desc">{{ item.desc }}</div>
      </div>
    </div>
    <!-- <div @click="goToFn('/m-index/hld')">
      <img src="../../assets/img/hld1.jpeg"/>
    </div>
    <div>
      <img src="../../assets/img/hld2.jpeg"/>
    </div> -->
    <Footer></Footer>
  </div>
</template>
<script>
import img1 from '../../assets/img/weichi.png'
import img2 from '../../assets/img/zhiyuan.png'
import img3 from '../../assets/img/config_estimate.png'
import img4 from '../../assets/img/config_portrait.png'
import Header from '../menhu/components/m-header.vue'
import Footer from '../menhu/components/m-footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      cardData: [
        {
          imgsrc: img1,
          title: '高考位次查询',
          desc: '高考位次查询是通过考生输入高考分数与批次，结合近三年一分一段表，帮助考生查询其分数在最近三年所对应的位次。',
          url: '/recommend/rank'
        },
        {
          imgsrc: img2,
          title: '高考志愿填报智能推荐',
          desc: '高考志愿填报智能推荐是通过考生查询到其高考位次后，根据其高考位次结合各高校专业在湖北省内的招生信息，推出一套科学便捷的志愿填报系统',
          url: '/recommend/volunteer'
        },
        
      ],
      imgArray: [
        require('../../assets/img/gaokao.jpeg'),
    ]
    }
  },
  methods: {
    goToFn(url) {
      this.$router.push(url)
    }
  }
}
</script>
<style lang="less">
.carousel {
  .el-carousel__container {
    height: 350px;
  }
}
</style>
<style lang="less" scoped>
.m-main {
  // display: flex;
  // padding: 50px 50px 0;
  // justify-content: space-around;
  // background: #f7f8f9;
  height: 100vh;
  overflow: auto;

  .m-main-bg {
    background: #fff;
    width: 80%;
    height: 400px;
    margin: 30px auto;
    text-align: center;
  }
  // position: relative;
  // &-img {
  //   width: 400px;
  //   margin: 0 auto;
  //   margin-bottom: 20px;
  //   position: absolute;
  //   right: 15%;
  //   > img {
  //     width: 100%;
  //     height: 100%;
  //
  // }
  .card-contain {
    display: flex;
    justify-content: center;
    padding: 20px 10% 0;
    margin-top: -20px;
    margin-bottom: 20px;
    text-align: center;
    > div {
      border: 1px solid #e7ebf0;
      border-radius: 10px;
      max-width: 320px;
      width: 20%;
      background: #ffffff;
      height: 420px;
      .img {
        width: 80%;
        height: 200px;
        border-radius: 10px 10px 0 0;
        margin: 5px auto;
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 10px 10px 0 0;
        }
      }
      .title {
        // text-align: center;
        padding: 20px;
        font-size: 24px;
        font-weight: bolder;
      }
      .desc {
        font-size: 12px;
        color: #6f6f79;
        padding: 0px 20px 10px;
      }
    }
    .card-contain__item {
      cursor: pointer;
    }
    .card-contain__item:hover {
      box-shadow: -2px 0px 5px 1px #e7ebf0, 0px -2px 5px 1px #e7ebf0, 2px 0px 5px 1px #e7ebf0, 0px 2px 5px 1px #e7ebf0;
    }
    .card-contain__item + .card-contain__item {
      margin-left: 20px;
    }
  }
  .card-contain + .card-contain {
    margin-left: 20px;
  }
  // >div {
  //   width: 36%;
  //   height: 300px;
  //   margin-right: 50px;
  //   border-radius: 20px;
  //   img {
  //     width: 100%;
  //     height: 100%;
  //     display: block;
  //     border-radius: 20px;
  //   }
  // }
  // >div:nth-child(2) {
  //   margin-right: 0;
  // }
}
.img {
  width: 80%;
  height: 400px;
}
</style>